import Bold from 'quill/formats/bold';
import QuillHeader from 'quill/formats/header';

export default class BasicHeader extends QuillHeader {
  static tagName = ['h1', 'h2', 'h3'];

  static create(value: string) {
    return super.create(parseInt(value, 10) > 3 ? 3 : value);
  }

  enforceAllowedChildren() {
    this.children.forEach((child) => {
      // @ts-expect-error
      if (child.statics.blotName === Bold.blotName) child.unwrap();
    });
  }
}
